const options = {
  5: "bg-gray-50/5",
  10: "bg-gray-50/10",
  25: "bg-gray-50/25",
  50: "bg-gray-50/50",
  75: "bg-gray-50/75",
  90: "bg-gray-50/90",
  100: "bg-gray-50",
};

const from = {
  5: "from-gray-50/5",
  10: "from-gray-50/10",
  25: "from-gray-50/25",
  50: "from-gray-50/50",
  75: "from-gray-50/75",
  90: "from-gray-50/90",
  100: "from-gray-50",
};

export default function getBackgroundGray50(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
